module.exports = __webpack_public_path__ + "img/speaker22.153a2bd8.png";